import Swiper, { Navigation, Pagination } from 'swiper';

import { ProductTileBuilder } from '../../components/ProductTile/ProductTileBuilder';
import { mapVariants } from '../../components/ProductTile/Utils';
import AdMindClick from '../../components/AdMind/click';

export default () => {
  // Get scheme values
  const productRecommendationsCarouselPods = document.querySelectorAll('[data-product-recommendations-carousel]');
  if (!productRecommendationsCarouselPods.length) return;

  const schemes = [];
  for (const pod of productRecommendationsCarouselPods) {
    const value = pod.getAttribute('data-scheme');
    if (value) schemes.push(value);
  }

  // Set up each Monetate Recommendation container based on each scheme
  schemes.forEach((scheme, index) => {
    document.addEventListener(`monetateLoaded${scheme}`, function (event) {
      const currentProductRecommendationsCarouselPod = productRecommendationsCarouselPods[index];
      // This will avoid render the same container twice
      if (currentProductRecommendationsCarouselPod.getAttribute('initialized') === 'true') {
        return;
      }

      const data = event.detail.monetateData;
      const title = event.detail.title;
      // if either data or title is null/empty/undefined, it will exit and be ready for new try
      if (!data || !title) return;
      // The Monetate's data is sometimes incomplete, e.i. just one product. So, it would need a new try
      if (data.length <= 1) return;

      // Set up initial container and the heading
      const podZero = document.createElement('div');
      const headingPod = document.createElement('div');
      const heading = document.createElement('h1');

      headingPod.classList.add('Section', 'ProductRecommendationsCarousel__heading-section');
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
      heading.classList.add('ProductRecommendationsCarousel__heading');
      heading.innerText = title;
      headingPod.appendChild(heading);
      podZero.appendChild(headingPod);

      const productRecommendationsCarouselWrapper = document.createElement('div');
      productRecommendationsCarouselWrapper.classList.add('ProductRecommendationsCarousel__component');
      productRecommendationsCarouselWrapper.setAttribute('data-index', index);

      // Build basic HTML layout to Swiper.js
      const swiperPod = document.createElement('div');
      swiperPod.classList.add('swiper');

      const swiperWrapper = document.createElement('div');
      swiperWrapper.classList.add('swiper-wrapper');

      const swiperPagination = document.createElement('div');
      swiperPagination.classList.add('swiper-pagination');

      swiperPod.appendChild(swiperWrapper);
      swiperPod.appendChild(swiperPagination);

      const swiperPrevButton = document.createElement('div');
      const swiperNextButton = document.createElement('div');
      swiperPrevButton.classList.add('swiper-button-prev');
      swiperNextButton.classList.add('swiper-button-next');

      // Previous and Next buttons only attached under one kind of scheme
      if (index == 0 && scheme == 'product1_rr') {
        swiperPod.appendChild(swiperPrevButton);
        swiperPod.appendChild(swiperNextButton);
      }

      // Wrap each single ProductTile in a swiper-slide element
      data.forEach((item) => {
        const swiperSlide = document.createElement('div');
        swiperSlide.classList.add('swiper-slide');
        const parseVariants = mapVariants(item.Child_Attributes);

        // Guard condition: it validates if there are available and sellable variants
        if (!parseVariants.filter((variant) => variant.Sellable).length) return;

        new ProductTileBuilder(item.Title, item.product_type)
          .makeUrl(item.Detail_URL)
          .makeNode(item.item_group_id, swiperSlide)
          .selectColor(item.selectedColor, parseVariants)
          .makeBadges(item.tags)
          .makeOptions(item.color)
          .makePrices()
          .build();

        swiperWrapper.appendChild(swiperSlide);
      });

      productRecommendationsCarouselWrapper.appendChild(swiperPod);

      podZero.appendChild(productRecommendationsCarouselWrapper);
      currentProductRecommendationsCarouselPod.prepend(podZero);

      // They aren't user-visible tasks. So, we can defer them
      setTimeout(() => {
        // Set up as "initialized" to current Product Recommendations Carousel pod
        // after appending all available product tiles
        currentProductRecommendationsCarouselPod.setAttribute('initialized', 'true');

        // Set up a 'click' event listener to track product information
        swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide, index) => {
          slide.addEventListener('click', function (event) {
            const item = data[index];
            const firstVariant = item.Child_Attributes[0];
            const comparePrices = item.Child_Attributes.map((variant) => {
              return variant.compare_at_price;
            });
            const comparePriceMax = Math.max(comparePrices);

            let currentTarget = event.currentTarget;
            let collectionName = currentTarget.closest('[data-collection]');
            let listName = '';

            if (collectionName) {
              listName = collectionName.dataset.collection;

              sessionStorage.setItem('rec_list_name', listName);

              const product = {
                id: item.item_group_id,
                title: item.Title,
                product_type: item.product_type,
                price: firstVariant.price,
                price_compare: firstVariant.compare_at_price,
                price_compare_max: comparePriceMax,
                tags: item.tags.split(','),
                variants: item.Child_Attributes,
                list_name: listName,
              };

              AdMindClick(product);
            }
          });
        });

        // Set up some Swiper.js paraments and initialize Swiper.js
        let carouselOptions = {
          modules: [Navigation, Pagination],
          slidesPerView: 2,
          allowTouchMove: true,
          pagination: {
            el: swiperPagination,
            clickable: true,
          },
          navigation:
            index == 0 && scheme == 'product1_rr'
              ? {
                  nextEl: swiperNextButton,
                  prevEl: swiperPrevButton,
                }
              : false,
          breakpoints: {
            // when window width is >= 640px
            767: {
              slidesPerView: index == 0 && scheme == 'product1_rr' ? 4 : 'auto',
              loopedSlides: index == 1,
              spaceBetween: 20,
              slidesPerGroup: 4,
              allowTouchMove: scheme !== 'product1_rr',
            },
          },
        };

        new Swiper(swiperPod, carouselOptions);
      }, 0);
    });
  });
};
